import PropTypes from 'prop-types';
import { VehicleTypes, Durations } from '../constants';

export const HolderInfoProps = PropTypes.shape({
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  email: PropTypes.string
});

export const HolderInfoDefaults = {
  first_name: '',
  last_name: '',
  email: ''
};

export const VehicleInfoProps = PropTypes.shape({
  vehicle_type: PropTypes.oneOf(Object.keys(VehicleTypes)),
  license_number: PropTypes.string
});

export const VehicleInfoDefaults = {
  vehicle_type: 'no-vehicle',
  license_number: ''
};

export const PassInfoProps = PropTypes.shape({
  facility_name: PropTypes.string,
  pass_name: PropTypes.string,
  pass_image: PropTypes.string,
  holder_info: HolderInfoProps,
  vehicle_info: VehicleInfoProps,
  start_date: PropTypes.string,
  duration: PropTypes.oneOf(Object.keys(Durations)),
  attendee_info: PropTypes.objectOf(PropTypes.number)
});

export const PassInfoDefaults = {
  facility_name: '',
  pass_name: '',
  pass_image: '',
  holder_info: HolderInfoDefaults,
  vehicle_info: VehicleInfoDefaults,
  start_date: null,
  duration: 'annual',
  attendee_info: {}
};
